module.exports = __webpack_public_path__ + "static/media/doctorPlan-group@3x.a440bbf1.png";